import React from "react"
import ThemeProvider from "@material-ui/styles/ThemeProvider"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import PracticeRoutinePost from "../../../components/practice-routine-post"
import theme from "../../../theme"

const summary = [
  {
    level: "Preliminary to Grade 2",
    time: "15 to 25 minutes",
    focus: "Posture, breathing, tone starts, simple finger patterns, short melodies",
    weeklyHabit: "Begin with long tones and stop before tone quality becomes tired",
  },
  {
    level: "Grades 3 to 4",
    time: "30 to 40 minutes",
    focus: "Tone, articulation, scales, breath planning, rhythm accuracy",
    weeklyHabit: "Practise scales slowly and mark breaths in each piece",
  },
  {
    level: "Grades 5 to 6",
    time: "45 to 60 minutes",
    focus: "Even fingers, dynamic control, articulation variety, tuning, phrase shape",
    weeklyHabit: "Use a tuner and metronome, then apply the same control to repertoire",
  },
  {
    level: "Grades 7 to 8",
    time: "60 to 75 minutes",
    focus: "Stamina, colour, vibrato control, style, advanced articulation",
    weeklyHabit: "Rotate tone, technique, repertoire detail, sight reading, and rest",
  },
]

const sections = [
  {
    title: "Preliminary to Grade 2: make a beautiful first sound",
    paragraphs: [
      "Early flute practice should begin with posture, relaxed breathing, and simple tone starts. Long tones can be short, but they should be focused and easy.",
      "Keep pieces in small sections so the student can maintain good tone. If the sound becomes airy or forced, take a break and reset.",
    ],
  },
  {
    title: "Grades 3 to 4: plan the breath",
    paragraphs: [
      "At this level, practice should include tone, scales, articulation, sight reading, and aural work. Marking breath points in pieces helps students avoid rushing or fading at phrase ends.",
      "Scales should stay slow enough for clean fingers and clear articulation. A beautiful scale is more useful than a fast uneven one.",
    ],
  },
  {
    title: "Grades 5 to 6: improve control",
    paragraphs: [
      "Middle-grade flute players need careful work on tuning, dynamics, finger evenness, and articulation variety. Use a tuner for long tones and a metronome for technical passages.",
      "Record short sections to check whether phrase shape and tone remain consistent across the full range.",
    ],
  },
  {
    title: "Grades 7 to 8: build stamina and colour",
    paragraphs: [
      "Advanced practice should rotate tone colour, vibrato control, style, technical passages, and performance runs. Plan enough rest so the embouchure stays fresh.",
      "Mock performances reveal whether breath planning, tuning, and articulation remain secure when the student plays without stopping.",
    ],
  },
  {
    title: "A simple weekly rhythm",
    paragraphs: [
      "Use a shared calendar for tone days, technique days, repertoire detail, sight reading, recording, rehearsal, and rest.",
      "Flute progress is easiest to hear when tone work happens regularly, even for a few minutes at a time.",
    ],
  },
]

const FlutePracticeRoutinesAmebLevels = () => (
  <ThemeProvider theme={theme}>
    <Layout>
      <SEO
        title="Flute Practice Schedule by AMEB Level"
        description="Plan flute practice for AMEB levels with routines for tone, breathing, scales, articulation, sight reading, aural work, and performance readiness."
      />
      <PracticeRoutinePost
        instrument="Flute"
        title="Flute practice routines for different AMEB levels"
        intro="A strong flute routine gives tone and breathing a regular place, then connects that control to technique, pieces, and performance confidence."
        sharedCalendarUrl="https://app.schoolcalendar.me/calendar/moody-gecko-74"
        image="blog-flute.png"
        imageAlt="Flute practice planning"
        summary={summary}
        sections={sections}
      />
    </Layout>
  </ThemeProvider>
)

export default FlutePracticeRoutinesAmebLevels
